export const SCOPE_GENERAL = 1
export const SCOPE_INITIAL = 2
export const SCOPE_BEACON = 3
